import moment from 'moment';

export const dateFormat = (date) => moment(date).format('l');

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
export const moneyFormat = (money) => formatter.format(money);
export const moneyWithoutDecimalsFormat = (money) =>
  formatter.format(money).replace(/\D00$/, '');

export const phoneFormat = (number) => {
  if (number) {
    const str = number.toString().replace(/\D+/g, '');
    const match = str.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : number;
  }
  return '';
};

export const zipFormat = (zip) => {
  let zipCode = '';
  if (zip) {
    zipCode = zip.match(/\b\d{5}\b/);
  }
  return zipCode;
};

export const address = ({ street, city, state, zip, apt }) => {
  const parts = [
    street,
    apt,
    city,
    state ? `${state} ${zipFormat(zip)}` : zipFormat(zip),
  ].filter(Boolean);

  return parts.join(', ');
};

export const CAPITALIZED_NAME_ACRONYMS = ['LLC'];

const capitalizedNameAcronyms = new Set(CAPITALIZED_NAME_ACRONYMS);

export const capitalize = (str) => {
  if (!str) {
    return '';
  }
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
      const acronymMatch = capitalizedWord.match(
        /^([^a-zA-Z0-9]*)([a-zA-Z0-9.]+)([^a-zA-Z0-9]*)$/,
      );

      if (!acronymMatch) {
        return capitalizedWord;
      }

      const [, prefix, value, suffix] = acronymMatch;
      const uppercaseValue = value.toUpperCase();
      const normalizedValue = uppercaseValue.replace(/\./g, '');

      return capitalizedNameAcronyms.has(normalizedValue)
        ? `${prefix}${uppercaseValue}${suffix}`
        : capitalizedWord;
    })
    .join(' ');
};

export default {
  dateFormat,
  moneyFormat,
  moneyWithoutDecimalsFormat,
  phoneFormat,
  zipFormat,
  address,
  capitalize,
};
